// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m6vegOUxB6UjYkgO{margin-top:16px}.m6vegOUxB6UjYkgO .gaJn1Q1H8CSAxC42{display:grid;width:100%;height:100%;min-height:256px;place-items:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBody": `m6vegOUxB6UjYkgO`,
	"emptyChart": `gaJn1Q1H8CSAxC42`
};
export default ___CSS_LOADER_EXPORT___;
